export const PDF_Y_PADDING = 35;
export const PDF_X_PADDING = 20;
export const PDF_TEXT_LINE_MARGIN = 2;
export const PDF_SECTIONS_PER_LINE = 2;
export const PDF_SECTIONS_HORIZONTAL_GAP = 40;
export const PDF_SECTIONS_VERTICAL_GAP = 12;
export const PDF_FILE_NAME = 'rack-construction.pdf';
export const PDF_FONT = 'open-sans';
export const PDF_FONT_SIZES = {
	X_LARGE: 24,
	LARGE: 20,
	MEDIUM: 16,
	SMALL: 12,
	X_SMALL: 10,
};
